import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { ErrorReportingService } from './app/observability/error-reporting.service';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(ref => ref.injector.get(ErrorReportingService).init())
  .catch(err => {
    console.error(err);
    // Boot falhou de vez: guarda no buffer para o coletor e mostra a tela de
    // erro recuperável do watchdog em vez do overlay cinza travado.
    (window as any).__bootErrors__ = (window as any).__bootErrors__ || [];
    (window as any).__bootErrors__.push(err);
    (window as any).__showBootError__?.(err);
  });
